import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Card, Typography, CardActions, CardContent, Button, Modal,
} from '@mui/material';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  outline: 'none',
  boxShadow: 24,
  p: 4,
};

const Pricing = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box id="pricing" sx={{ width: '100%', padding: { xs: '30px 50px', sm: '60px 100px' }, background: '#F2F7F8' }}>
      <Box sx={{
        width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
      }}
      >
        <Typography sx={{ width: { xs: '100%', sm: '30%' }, fontWeight: '200', fontSize: '30px' }}>Pricing Plan</Typography>
      </Box>
      <Box sx={{
        width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', alignItems: 'center', gap: '40px', margin: '20px auto',
      }}
      >
        <Card sx={{ width: { xs: '100%', sm: '20%' }, textAlign: 'center', padding: '20px 0 7px 0' }}>
          <CardContent>
            <Box sx={{ marginBottom: '10px' }}>
              <Typography sx={{ color: '#474E5D', fontWeight: '400', lineHeight: '30px' }}>TRANSCRIPTION</Typography>
              <Typography
                onClick={handleOpen}
                sx={{
                  color: '#3E8CD9', fontWeight: '300', lineHeight: '30px', cursor: 'pointer',
                }}
              >
                Languages Available
              </Typography>
              <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}><span style={{ color: '#474E5D', fontWeight: '500' }}>$1.50/min</span></Typography>
            </Box>
            <hr style={{ border: '1px solid #474E5D' }} />
            <Box sx={{ marginTop: '10px' }}>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>Unlimited speakers</Typography>
              </Box>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>Add special instructions</Typography>
              </Box>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>Intelligent Verbatim</Typography>
              </Box>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>24hrs - 48hrs delivery</Typography>
              </Box>
            </Box>
            <CardActions sx={{
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
            }}
            >
              <Button onClick={() => navigate('/upload_transcript')} variant="contained" size="small" color="primary" sx={{ backgroundColor: '#3E8CD9', color: '#B7E8F5', padding: '10px 90px' }}>
                Order
              </Button>
            </CardActions>
          </CardContent>
        </Card>

        <Card sx={{ width: { xs: '100%', sm: '20%' }, textAlign: 'center', padding: '20px 0 7px 0' }}>
          <CardContent>
            <Box sx={{ marginBottom: '10px' }}>
              <Typography sx={{ color: '#474E5D', fontWeight: '400', lineHeight: '30px' }}>TRANSLATION</Typography>
              <Typography
                onClick={handleOpen}
                sx={{
                  color: '#3E8CD9', fontWeight: '300', lineHeight: '30px', cursor: 'pointer',
                }}
              >
                Languages Available
              </Typography>
              <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}><span style={{ color: '#474E5D', fontWeight: '500' }}>$12.5/page</span></Typography>
            </Box>
            <hr style={{ border: '1px solid #474E5D' }} />
            <Box sx={{ marginTop: '10px' }}>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>Add special instructions</Typography>
              </Box>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>All languages - one price</Typography>
              </Box>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>Available For Express</Typography>
              </Box>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>24hrs - 48hrs delivery</Typography>
              </Box>
            </Box>
            <CardActions sx={{
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
            }}
            >
              <Button onClick={() => navigate('/upload_translation')} variant="contained" size="small" color="primary" sx={{ backgroundColor: '#3E8CD9', color: '#B7E8F5', padding: '10px 90px' }}>
                Order
              </Button>
            </CardActions>
          </CardContent>
        </Card>

        <Card sx={{ width: { xs: '100%', sm: '20%' }, textAlign: 'center', padding: '20px 0 7px 0' }}>
          <CardContent>
            <Box sx={{ marginBottom: '10px' }}>
              <Typography sx={{ color: '#474E5D', fontWeight: '400', lineHeight: '30px' }}>CAPTIONS</Typography>
              <Typography
                onClick={handleOpen}
                sx={{
                  color: '#3E8CD9', fontWeight: '300', lineHeight: '30px', cursor: 'pointer',
                }}
              >
                Languages Available
              </Typography>
              <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}><span style={{ color: '#474E5D', fontWeight: '500' }}>$1.5/min</span></Typography>
            </Box>
            <hr style={{ border: '1px solid #474E5D' }} />
            <Box sx={{ marginTop: '10px' }}>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>Unlimited speakers</Typography>
              </Box>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>Add special instructions</Typography>
              </Box>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>Word-for-word sinking</Typography>
              </Box>
              <Box sx={{
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '5px',
              }}
              >
                <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
                <Typography sx={{ color: '#949EB2', fontWeight: '300', lineHeight: '30px' }}>24hrs - 48hrs delivery</Typography>
              </Box>
            </Box>
            <CardActions sx={{
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
            }}
            >
              <Button onClick={() => navigate('/upload_captions')} variant="contained" size="small" color="primary" sx={{ backgroundColor: '#3E8CD9', color: '#B7E8F5', padding: '10px 90px' }}>
                Order
              </Button>
            </CardActions>
          </CardContent>
        </Card>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ color: '#3E8CD9' }}>
            Langauges We Work With
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, fontWeight: '300' }}>
            <span style={{ fontWeight: 'bold', color: '#3E8CD9' }}>Transcription:</span>
            {' '}
            English, French, Spanish, Arabic
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, fontWeight: '300' }}>
            <span style={{ fontWeight: 'bold', color: '#3E8CD9' }}>Captions:</span>
            {' '}
            English, French, Spanish, Arabic
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, fontWeight: '300' }}>
            <span style={{ fontWeight: 'bold', color: '#3E8CD9' }}>Translation:</span>
            {' '}
            English, French, Spanish, Arabic
          </Typography>
        </Box>
      </Modal>
    </Box>
  );
};

export default Pricing;
